export interface SettingsAttorneysRouter {
  goToDetail(id: string): void;
  goToList(query?: string): void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SettingsAttorneysRouter = Symbol('SettingsAttorneysRouter');
